// LoadingOverlay.tsx
import React from 'react';
import Spinner from '@cloudscape-design/components/spinner';

export const LoadingOverlay = () => (
  <div style={{
    position: 'fixed',
    top: 0, left: 0,
    width: '100vw', height: '100vh',
    backgroundColor: 'rgba(255,255,255,0.6)',
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'auto',
  }}>
    <Spinner size="large" />
  </div>
);
